import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import { SideBarSignalState, SideBarStore } from '@data-access/shared';
import { computed, Type, ViewContainerRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';

export const HANDLE_SIDE_BAR_SIGNAL_STORE = signalStore(
  withState<SideBarStore>(() => ({
    currentComponentRef: null,
    currentViewContainerRef: null,
    toggleSideBar: false,
  })),
  withProps((store) => ({
    store,
  })),
  withComputed(
    ({ currentViewContainerRef, currentComponentRef, toggleSideBar }) => ({
      $currentComponentRef: computed(() => currentComponentRef()),
      $currentViewContainerRef: computed(() => currentViewContainerRef()),
      $toggleSideBar: computed(() => toggleSideBar()),
    }),
  ),
  withMethods(({ currentComponentRef, currentViewContainerRef, ...store }) => ({
    clearCurrentComponentRef: () => {
      currentComponentRef()?.destroy();
      patchState(store, { currentComponentRef: null });
    },
    clearCurrentViewContainerRef: () => {
      currentComponentRef()?.destroy();
      patchState(store, {
        currentComponentRef: null,
        currentViewContainerRef: null,
      });
    },
    setCurrentViewContainerComponent: (component: ComponentType<unknown>) => {
      if (currentViewContainerRef() && component) {
        currentViewContainerRef()?.clear();
        const _ref = currentViewContainerRef()?.createComponent(component);
        patchState(store, { currentComponentRef: _ref });
      }
    },
    setCurrentViewContainerRef: (vcr: ViewContainerRef) =>
      patchState(store, { currentViewContainerRef: vcr }),
    toggleSideBarOpen: (isOpen: boolean) =>
      patchState(store, { toggleSideBar: isOpen }),
  })),
) satisfies Type<SideBarSignalState>;
